import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/antd.min.css';  // Updated import path
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <div style={{ padding: 20 }}>
      <App />
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


// Replace this:
// serviceWorkerRegistration.register();

// With this:
// 检查浏览器支持
if ('serviceWorker' in navigator) {
  // 页面加载完成后注册 Service Worker
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered successfully:', registration);
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  });
} else {
  console.log('Service Worker is not supported');
}
